import {
  addMedicalRecord,
  deleteMedicalRecord,
  getMedicalDeptList,
  getMedicalIncomeList,
  getMedicalRecordList,
  updateMedicalRecord,
} from '../services';

export default {
  namespace: 'hospitalRevenue',
  state: {
    medicalDeptList: [],
  },
  effects: {
    // 医疗收入明细列表
    *getMedicalIncomeList({ payload }, { call }) {
      const res = yield call(getMedicalIncomeList, payload);
      return res;
    },

    // 病案数据列表
    *getMedicalRecordList({ payload }, { call }) {
      const res = yield call(getMedicalRecordList, payload);
      return res;
    },

    // 补录病案信息
    *addMedicalRecord({ payload }, { call }) {
      const res = yield call(addMedicalRecord, payload);
      return res;
    },

    // 更新补录病案信息
    *updateMedicalRecord({ payload }, { call }) {
      const res = yield call(updateMedicalRecord, payload);
      return res;
    },

    // 删除病案信息
    *deleteMedicalRecord({ payload }, { call }) {
      const res = yield call(deleteMedicalRecord, payload);
      return res;
    },

    // 查询his系统单位
    *getMedicalDeptList({ payload }, { call, put, select }) {
      const medicalDeptList = yield select(state => state.hospitalRevenue.medicalDeptList);
      if (medicalDeptList?.length) return;
      const res = yield call(getMedicalDeptList, payload);
      yield put({
        type: 'setState',
        payload: {
          medicalDeptList: res || {},
        },
      });
    },
  },
  reducers: {
    setState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
